import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../shared/constants/constants";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { getPartyById } from "./configuration";

export const downloadInvoicePdf = createAsyncThunk(
    "paymentInvoice/downloadpdf",
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.downloadInvoicePdf;
        try {
            const response = await axiosPost(url, reqBody);
            // const downloadURL = response.data.downloadUrl;
            // const downloadLink = document.createElement("a");
            // document.body.appendChild(downloadLink);
            // downloadLink.href = downloadURL;
            // downloadLink.download = "paymentInvoice.pdf";
            // downloadLink.target = "_blank";
            // downloadLink.click();
            // document.body.removeChild(downloadLink);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            console.log(error);
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const updatePaymentInvoice = createAsyncThunk(
    "paymentInvoice/invoice/update",
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        let url = `${API_ENDPOINTS.updatePaymentInvoice}`;
        try {
            const response = await axiosPost(`${url}`, reqBody);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const updatePaymentInvoiceStatus = createAsyncThunk(
    "paymentInvoice/invoice/updateInvoiceStatus",
    async (reqBody: any, { rejectWithValue }) => {
        const { axiosPost } = useCustomAxios();
        let url = `${API_ENDPOINTS.updatePaymentInvoiceStatus}`;
        try {
            const response = await axiosPost(`${url}`, reqBody);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const searchPaymentInvoice = createAsyncThunk(
    "paymentInvoice/invoice/searchInvoice",
    async (reqBody: any, { dispatch, rejectWithValue }) => {
        const { axiosPost } = useCustomAxios();
        let url = `${API_ENDPOINTS.searchPaymentInvoice}`;
        const queryParams = reqBody.queryParams;
        const body = reqBody.body;
        Object.entries(queryParams).forEach(
            ([key, value], index) =>
                (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
        );
        try {
            const response = await axiosPost(`${url}`, body);
            if (response.status === 200) {
                let invoices = response.data?.invoices;
                return {
                    data: {
                        invoices: invoices,
                        ...response.data
                    }, status: response.status
                };
            } else {
                return {
                    error: response.data.message,
                    status: response.status,
                };
            }
        } catch (error: any) {
            return rejectWithValue(error.response.data || error.response.data.message);
        }
    }
);

export const getPaymentInvoiceById = createAsyncThunk(
    'paymentInvoice/invoice',
    async (paymentInvoiceId: string) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.getPaymentInvoiceById;
            url = url.replace(":invoiceId", paymentInvoiceId);
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const downloadOrderInvoicePdf = createAsyncThunk(
    "paymentInvoice/invoice/downloadPdf",
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.downloadInvoicePdf;
        try {
            const response = await axiosPost(url, reqBody);
            const downloadURL = response.data.downloadUrl;
            const downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = downloadURL;
            downloadLink.download = "paymentInvoice.pdf";
            downloadLink.target = "_blank";
            downloadLink.click();
            document.body.removeChild(downloadLink);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            console.log(error);
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const createExternalInvoice = createAsyncThunk(
    "paymentInvoice/invoice/createExternalInvoice",
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.createExternalInvoice;
        try {
            const response = await axiosPost(url, reqBody);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            console.log(error);
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const ingestInvoiceToTally = createAsyncThunk(
    "invoice/ingestInvoiceToTally",
    async (requestPayload: any) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.ingestInvoiceToTally;
        try {
            const response = await axiosPost(url, requestPayload);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            console.log(error);
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);
